// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"50963ae5","769":"397f9cc4"}[chunkId] + ".chunk.js";
};